export default __webpack_public_path__ + "static/media/pair.7c43b1fa.png";